import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { PremiumIcon } from 'javascripts/analytics/components/premium_icon';
import { TableHeadSortingCell } from 'javascripts/analytics/components/table_head_sorting_cell';
import { inMode } from 'javascripts/analytics/config/permissions';
import { NavLink } from 'react-router-dom';

export class DocumentsTabTable extends React.Component {
  static propTypes = {
    docs: PropTypes.array.isRequired,
    dayCount: PropTypes.number.isRequired,
  };

  state = {
    sortBy: 'thirtyDayViews',
    sortDirection: 'DESC',
  };

  sortedDocs = () => {
    const docs = _.sortBy(
      this.props.docs,
      function (doc) {
        return doc[this.state.sortBy];
      },
      this,
    );

    if (this.state.sortDirection === 'ASC') return docs;

    return _.clone(docs).reverse();
  };

  updateSort = (sortBy) => {
    return function () {
      this.setState({
        sortBy: sortBy,
        sortDirection: this.state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
      });
    }.bind(this);
  };

  perDocumentPages = () => {
    return inMode('premium');
  };

  upgradeableForPerDocument = () => {
    return inMode('upgradeable');
  };

  shouldShowImpactColumn = () => {
    return this.perDocumentPages() || this.upgradeableForPerDocument();
  };

  renderDocRows = () => {
    return _.map(
      this.sortedDocs(),
      function (doc, index) {
        const impactLink = this.props.match.url + '/' + doc.id;

        return (
          <tr key={index}>
            <td>
              {inMode('premium') ? (
                <NavLink to={impactLink}>{doc.title}</NavLink>
              ) : (
                <a href={doc.internal_url}>{doc.title}</a>
              )}
            </td>
            <td className="u-fontMonospaced u-fs12">
              {$h.commaizeInt(doc.thirtyDayViews)}
            </td>
            <td className="u-fontMonospaced u-fs12">
              {$h.commaizeInt(doc.thirtyDayUniques)}
            </td>
            <td className="u-fontMonospaced u-fs12">
              {$h.commaizeInt(doc.thirtyDayDownloads)}
            </td>
            <td className="u-fontMonospaced u-fs12">
              {$h.commaizeInt(doc.allTimeViews)}
            </td>
            <td className="u-fontMonospaced u-fs12">
              {$h.commaizeInt(doc.allTimeDownloads)}
            </td>
            {this.shouldShowImpactColumn() && (
              <td className="u-fontMonospaced u-fs12 u-taCenter u-verticalAlignMiddle">
                {inMode('premium') ? (
                  <NavLink
                    className="Button Button--sm Button--inverseBlue u-ph3x"
                    to={impactLink}
                  >
                    Impact
                  </NavLink>
                ) : (
                  <a
                    className="Button Button--sm Button--inverseBlue u-ph3x"
                    href={
                      inMode('upgradeable') &&
                      $r.upgrade_url({
                        feature: 'academia_analytics_expanded',
                        trigger: 'documents-table-impact-cell',
                      })
                    }
                  >
                    Impact
                  </a>
                )}
              </td>
            )}
          </tr>
        );
      }.bind(this),
    );
  };

  renderHeadCell = (column, style, text) => {
    return (
      <TableHeadSortingCell
        sortingByColumn={this.state.sortBy === column}
        sortDirection={this.state.sortDirection}
        onClick={this.updateSort(column)}
        style={style}
      >
        {text}
      </TableHeadSortingCell>
    );
  };

  renderImpactColumnHeadContentsWrapper = (children) => {
    const upgradeUrl = $r.upgrade_url({
      feature: 'analytics',
      trigger: 'documents-table-impact-header-cell',
    });

    if (inMode('premium')) {
      return (
        <span className="js-PremiumIconContainerHoverWrapper PremiumIconContainerHoverWrapper">
          {children}
        </span>
      );
    } else {
      return (
        <a
          className="js-PremiumIconContainerHoverWrapper PremiumIconContainerHoverWrapper u-linkUnstyled u-textDecorationNone"
          href={upgradeUrl}
        >
          {children}
        </a>
      );
    }
  };

  renderImpactColumnHead = () => {
    const upgradeUrl = $r.upgrade_url({
      feature: 'academia_analytics_expanded',
      trigger: 'documents-table-impact-header-cell',
    });
    return (
      <th className="u-taCenter u-fw400" style={{ width: '116px' }}>
        {this.renderImpactColumnHeadContentsWrapper(
          <span>
            <PremiumIcon
              style={{ top: '-1px' }}
              className="u-positionRelative"
              popoverBodyText="Get detailed impact reports to show the impact of each paper."
              popoverLinkUrl={upgradeUrl}
              disableHoverBehavior={inMode('premium')}
            />
            <span className="u-fw700">&nbsp; Impact</span>
          </span>,
        )}
      </th>
    );
  };

  render() {
    return (
      <div className="panel panel-flat  a-fadeInDown">
        <div className="panel-body" style={{ overflowX: 'auto' }}>
          <table
            className="analytics-dashboard-data-table table table-bordered table-hover u-mb0x"
            style={{ tableLayout: 'auto' }}
          >
            <thead>
              <tr>
                <th>Title</th>
                {this.renderHeadCell(
                  'thirtyDayViews',
                  { width: '11%' },
                  this.props.dayCount + '-day views',
                )}
                {this.renderHeadCell(
                  'thirtyDayUniques',
                  { width: '12.5%' },
                  this.props.dayCount + '-day uniques',
                )}
                {this.renderHeadCell(
                  'thirtyDayDownloads',
                  { width: '14%' },
                  this.props.dayCount + '-day downloads',
                )}
                {this.renderHeadCell(
                  'allTimeViews',
                  { width: '11.5%' },
                  'All-time views',
                )}
                {this.renderHeadCell(
                  'allTimeDownloads',
                  { width: '14.5%' },
                  'All-time downloads',
                )}
                {this.shouldShowImpactColumn() && this.renderImpactColumnHead()}
              </tr>
            </thead>
            <tbody>{this.renderDocRows()}</tbody>
          </table>
        </div>
      </div>
    );
  }
}
